const Generic = require("../GenericThemeFunctions")

module.exports = {
    defaultLanguage: 'en',
    scssVariables: './src/styles/promargentina2026',
    randomNickname:  () => { return Generic.RandomNickname() },
    defaultPassword: 'default'
}